'use strict';
import { tns } from "tiny-slider"

class PageListCarousel {
    constructor() {
        const sliders = [...document.querySelectorAll('.page-list-carousel__list')];
        if (sliders) {
            sliders.forEach((slider) => {
                const hasThreeItems = slider.classList.contains('page-list-carousel__list--grid');
                tns({
                    container: slider,
                    slideBy: 'page',
                    autoplay: false,
                    controls: true,
                    nav: false,
                    speed: 250,
                    mouseDrag: true,
                    gutter: 16,
                    controlsText: ['', ''],
                    items: 1,
                    loop: false,
                    onInit: function (instance) {
                        instance.nextButton.ariaLabel = "Framåt";
                        instance.prevButton.ariaLabel = "Bakåt";
                    },
                    responsive: {
                        768: {
                            items: 2,
                            fixedWidth: hasThreeItems ? false : undefined,
                            gutter: 24,
                        },
                        992: {
                            items: 3,
                            fixedWidth: hasThreeItems ? false : undefined,
                            gutter: 24,
                        }
                    }
                });
            })

        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new PageListCarousel();
});